import React, { Component } from "react";
import Data from "./Data";
import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import axios from "axios";
import $ from "jquery";
import AES128 from "./AES128";
import InfiniteScroll from "react-infinite-scroller";
import StudentsList from "./StudentsList";
import Classes2List from "./Classes2List";

class Classes2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: "",
      id: "",
      fields: {
        name: "",
        family: "",
        studentname: "",
        studentphone: "",
      },
      open: true,
      openReg: false,
      dialog: <div></div>,
      classinfo: {},
      errors: {},
    };
  }

  handleChange(event) {
    let fields = this.state.fields;
    let target = event.target;
    fields[target.name] = target.value;
    fields["studentname"] = fields["name"] + " " + fields["family"];
    this.setState({ fields });
  }
  handleChangeDay(event, dayid, masterid, instrumentid) {
    let target = event.target;
    let newdayid = target.value;
    let newday = target.children[target.value].innerText;

    if (dayid != newdayid) {
      $("#waitspinner").modal("show");

      let data = new FormData();
      data.append("dayid", dayid);
      data.append("masterid", masterid);
      data.append("instrumentid", instrumentid);
      data.append("newdayid", newdayid);
      data.append("newday", newday);

      axios
        .post(Data.server + "editClasses.php", data)
        .then((response) => {
          console.log(response.data);

          $("#waitspinner").modal("hide");
          $("div.modal-backdrop.fade.show").remove();

          if (response.data === "ok") {
            this.props.toast(
              "ویرایش با موفقیت انجام شد",
              3000,
              "bg-success",
              () => {
                $("#liveToast").toast("show");
                window.location.reload();
              }
            );
          }

          if (response.data.includes("error update")) {
            this.props.toast("خطای داخلی رخ داد", 3000, "bg-danger", () => {
              $("#liveToast").toast("show");
            });
          }
        })
        .catch((error) => {
          $("#progressTop").addClass("invisible");
          $("#r_fab").addClass("animate__animated animate__zoomIn");
          console.log(error);
        });
    }
  }

  handleSubmit3(event) {
    event.preventDefault();

    this.handleValidation3((valid) => {
      if (valid) {
        this.handleRequest3();
      } else {
        const { errors } = this.state;
      }
    });
  }
  handleValidation3(callback) {
    let { fields } = this.state;
    let errors = this.state.errors;
    let formIsValid = true;

    if (fields.name === "") {
      formIsValid = false;
      errors["name"] = "لطفا نام هنرجو را وارد کنید!";
    } else {
      errors["name"] = null;
    }

    if (fields.family === "") {
      formIsValid = false;
      errors["family"] = "لطفا نام خانوادگی هنرجو را وارد کنید!";
    } else {
      errors["family"] = null;
    }
    if (fields.studentphone === "") {
      formIsValid = false;
      errors["studentphone"] = "لطفا شماره تلفن هنرجو را وارد کنید!";
    } else {
      errors["studentphone"] = null;
    }

    if (!fields.studentphone.startsWith("09")) {
      formIsValid = false;
      errors["studentphone"] =
        "لطفا شماره تلفن را با فرمت 09xxxxxxxxx وارد کنید!";
    } else if (fields.studentphone.startsWith("09")) {
      errors["studentphone"] = null;
    }
    this.setState({ errors }, () => {
      return callback(formIsValid);
    });
  }
  handleRequest3() {
    const { name, family, studentname, studentphone } = this.state.fields;
    sessionStorage.setItem("studentname", studentname);
    sessionStorage.setItem("studentphone", studentphone);
    this.setState({
      dialog: (
        <Dialog
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          open={this.state.open}
          className="text-right"
          onClose={() => this.handleClose()}
        >
          <DialogContent>
            <DialogContentText
              className="text-center"
              id="alert-dialog-description"
            >
              <div
                id="loading"
                className="d-flex mt-3 justify-content-center animate__animated animate__zoomIn"
              >
                <h4>درحال بارگذاری ...</h4>
                <CircularProgress className="mr-3" color="secondary" />
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      ),
    });

    let data = new FormData();
    data.append("name", name);
    data.append("family", family);
    data.append("phone", studentphone);
    axios
      .post(Data.mainserver + "Register.php", data)
      .then((response2) => {
        console.log("request", response2.data);

        this.handleClose();
        try {
          let res2 = JSON.parse(JSON.stringify(response2.data));

          if (res2.hasOwnProperty("token")) {
            this.handleReg();
          }
        } catch (e) {
          console.log(e);
        }
        if (response2.data === "duplicate_phone") {
          this.handleReg();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleReg() {
    this.setState({
      dialog: (
        <Dialog
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          open={this.state.open}
          className="text-right"
          onClose={() => this.handleClose()}
        >
          <DialogContent>
            <DialogContentText
              className="text-center"
              id="alert-dialog-description"
            >
              <div
                id="loading"
                className="d-flex mt-3 justify-content-center animate__animated animate__zoomIn"
              >
                <h4>درحال بارگذاری ...</h4>
                <CircularProgress className="mr-3" color="secondary" />
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      ),
    });

    const { classinfo } = this.state;
    let token = localStorage.getItem("token");
    let data2 = new FormData();
    data2.append("token", token);
    data2.append("id", classinfo["id"]);
    axios
      .post(Data.mainserver + `getClass3.php`, data2)
      .then((response) => {
        console.log("reg", response.data);
        if (response.data.hasOwnProperty("data")) {
          const { data } = response.data;
          $("#masters").removeClass("novisible");

          let token = AES128.encrypt(AES128.keyy, AES128.ivv, data[0]["id"]);

          var qp = new URLSearchParams(window.location.search);
          qp.set("token", token);

          window.location.href = "/pay?" + qp.toString();
        }
        if (response.data.hasOwnProperty("no_item")) {
          $("#no_item").removeClass("novisible");
        }
        $("#select_instrument").removeClass("novisible");
        $("#loading").addClass("novisible");
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentDidMount() {
    // let studentname = sessionStorage.getItem('studentname');
    // let studentphone = sessionStorage.getItem('studentphone');
    // this.setState({
    //     studentname:studentname,
    //     studentphone:studentphone
    // });
  }
  handleReq(data) {
    sessionStorage.setItem("studentname", data["studentname"]);
    sessionStorage.setItem("studentphone", data["studentphone"]);

    let fields = {
      name: data["name"],
      family: data["family"],
      studentname: data["studentname"],
      studentphone: data["studentphone"],
    };
    this.setState({
      fields: fields,
      openReg: true,
      classinfo: data,
    });
  }

  handleCancel(doo, dayid, masterid) {
    $("#waitspinner").modal("show");

    let data = new FormData();
    data.append("dayid", dayid);
    data.append("masterid", masterid);
    data.append("do", doo);
    axios
      .post(Data.mainserver + "cancelClass.php", data)
      .then((response) => {
        $("#waitspinner").modal("hide");
        $("div.modal-backdrop.fade.show").remove();

        if (response.data === "ok") {
          this.props.toast(
            "ویرایش با موفقیت انجام شد",
            3000,
            "bg-success",
            () => {
              $("#liveToast").toast("show");
              window.location.reload();
            }
          );
        } else {
          this.props.toast("خطای داخلی رخ داد", 3000, "bg-danger", () => {
            $("#liveToast").toast("show");
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleClose() {
    this.setState({
      dialog: <div />,
    });
  }

  handleCloseReg(e) {
    e.preventDefault();

    this.setState({
      openReg: false,
    });
  }
  handleDelete(id, modalid) {
    $("#" + modalid).modal("hide");
    $("#waitspinner").modal("show");

    let token = localStorage.getItem("token");
    let data = new FormData();
    data.append("token", "");
    data.append("id", id);
    axios
      .post(Data.server + `deleteInstrument.php`, data)
      .then((response) => {
        $("#waitspinner").each(function () {
          $(this).modal("hide");
        });
        if (response.data === "ok") {
          this.props.toast("حذف با موفقیت انجام شد", 3000, "bg-success", () => {
            $("#liveToast").toast("show");
            window.location.reload();
          });
        }
        if (response.data === "wrong id") {
          this.props.toast(
            "خطا : شناسه هنرجو اشتباه است",
            "3000",
            "bg-danger",
            () => {
              $("#liveToast").toast("show");
            }
          );
        }
        if (response.data.hasOwnProperty("no_item")) {
          $("#no_item").removeClass("invisible");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    const { data, noinfo } = this.props;
    const { errors, time, dialog } = this.state;
    const { name, family, studentname, studentphone } = this.state.fields;
    console.log(data);
    return (
      <div className="container text-center">
        <div className="section-title">
          <h3>{"لیست کلاس ها"}</h3>
        </div>

        {dialog}

        <div className=" nav nav-pills nav-fill flex-sm-row">
          {data.map((d, i) => (
            <div key={i} className="nav-item">
              <a
                className={
                  i === 0
                    ? "flex-sm-fill nav-link active"
                    : "flex-sm-fill nav-link"
                }
                data-toggle="tab"
                href={"#day" + i}
              >
                {d["dayname"] + " ها"}
              </a>
            </div>
          ))}
        </div>

        <div className="tab-content text-center p-3">
          {data.map((d, i) => (
            <div
              key={i}
              className={
                i === 0 ? "tab-pane fade show active" : "tab-pane fade"
              }
              id={"day" + i}
            >
              <div className="row">
                {data[i]["masters"].map((dd, index) => (
                  <div className="col-12" key={index}>
                    <div className="card box-shadow mt-4 ">
                      <div className="card-body flex-column">
                        <h3 className="mt-2">{"استاد " + dd["mastername"]}</h3>
                        <div className="d-flex flex-row justify-content-center align-items-center">
                          <h4 className="mt-2">{dd["instrumentname"]}</h4>
                          <img
                            height="64"
                            width="64"
                            src={
                              Data.mainserver + "icons/" + dd["instrumentpic"]
                            }
                          />
                        </div>
                        <img
                          className="circle-icon"
                          height="128"
                          width="128"
                          src={
                            dd["masterpic"] === ""
                              ? Data.mainserver + "icons/user.png"
                              : Data.mainserver + "images/" + dd["masterpic"]
                          }
                          alt={"استاد " + dd["mastername"]}
                        />
                        <form className="login-form mx-auto">
                          <div className="form-group text-right">
                            <label>تغییر روز</label>
                            <select
                              className="form-control"
                              name="dayid"
                              value={d["dayid"]}
                              onChange={(e) =>
                                this.handleChangeDay(
                                  e,
                                  d["dayid"],
                                  dd["masterid"],
                                  dd["instrumentid"]
                                )
                              }
                            >
                              <option value={0}>شنبه</option>
                              <option value={1}>یکشنبه</option>
                              <option value={2}>دوشنبه</option>
                              <option value={3}>سه شنبه</option>
                              <option value={4}>چهارشنبه</option>
                              <option value={5}>پنج شنبه</option>
                            </select>
                            <span
                              className="invalid-feedback rtl"
                              style={{
                                display: errors["inst"] ? "block" : "none",
                              }}
                            >
                              {errors["inst"]}
                            </span>
                            <div className="btn-group mt-2 h-100">
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={(e) =>
                                  this.handleCancel(
                                    "+",
                                    d["dayid"],
                                    dd["masterid"]
                                  )
                                }
                              >
                                کنسلی
                              </button>
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={(e) =>
                                  this.handleCancel(
                                    "-",
                                    d["dayid"],
                                    dd["masterid"]
                                  )
                                }
                              >
                                جبرانی
                              </button>

                              {/* <div className="modal fade" id={"cancelClass"+index} tabIndex="-1" aria-labelledby={"cancelClassLabel"+index}
                                                            aria-hidden="true">
                                                                <div className="modal-dialog modal-dialog-scrollable modal-sm modal-dialog-centered">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h6 className="modal-title" id={"cancelClassLabel"+index}>{"کنسلی کلاس"}</h6>
                                                                            <button type="button" className="close text-left ml-0" data-dismiss="modal" aria-label="Close">
                                                                                <span aria-hidden="true">&times;</span>
                                                                            </button>
                                                                        </div>
                                                                    <div className="modal-body">
                                                                        {"آیا از کنسلی کلاس مطمئن هستید ؟"}
                                                                        <br />
                                                                        <strong>{"با این کار به تاریخ تمام کلاس ها 1 هفته اضافه میشود"}</strong>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <div className="btn-group">
                                                                            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={(e) => this.handleCancel(e,d['dayid'],dd['masterid'])}>بله</button>
                                                                            <button type="button" className="btn btn-secondary" data-dismiss="modal">خیر</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal fade" id={"jobranClass"+index} tabIndex="-1" aria-labelledby={"jobranClassLabel"}
                                                            aria-hidden="true">
                                                                <div className="modal-dialog modal-dialog-scrollable modal-sm modal-dialog-centered">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h6 className="modal-title" id={"jobranClassLabel"}>{"جبرانی کلاس"}</h6>
                                                                            <button type="button" className="close text-left ml-0" data-dismiss="modal" aria-label="Close">
                                                                                <span aria-hidden="true">&times;</span>
                                                                            </button>
                                                                        </div>
                                                                    <div className="modal-body">
                                                                        {"آیا از جبرانی کلاس مطمئن هستید ؟"}
                                                                        <br />
                                                                        <strong>{"با این کار از تاریخ تمام کلاس ها 1 هفته کم میشود"}</strong>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <div className="btn-group">
                                                                            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={(e) => this.handleCancel(e,d['dayid'],dd['masterid'])}>بله</button>
                                                                            <button type="button" className="btn btn-secondary" data-dismiss="modal">خیر</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                            </div>
                          </div>
                        </form>
                      </div>
                      <div className="card-footer text-center d-flex flex-column justify-content-center align-items-center">
                        <div key={i} className="table-responsive radius">
                          <table className="table table-condensed table-bordered table-striped table-hover text-center">
                            <thead>
                              <tr className="table-secondary">
                                <th>روز</th>
                                <th>ساعت</th>
                                <th>وضعیت</th>
                                <th>رزرو شده تا تایخ</th>
                                <th>رزرو شده توسط</th>
                                <th>ویرایش</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dd["infos"].map((ddd, iii) => (
                                <Classes2List
                                  toast={this.props.toast.bind(this)}
                                  products={ddd}
                                  index={iii}
                                />
                              ))}
                              )
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Classes2;
